import React from 'react';
import { inject, observer } from 'mobx-react';

import './MoveInAppWarning.css';

const WarnIcon = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--amber)"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flex: 'none', marginTop: 1 }}
  >
    <path d="M12 9v4M12 17h.01" />
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
  </svg>
);

const MoveInAppWarning = inject('translationsStore')(
  observer(({ translationsStore, className, style }) => (
    <div className={`MoveInAppWarning${className ? ` ${className}` : ''}`} style={style}>
      <WarnIcon />
      <span>{translationsStore.translate('movein.stepWelcome.appInstruction')}</span>
    </div>
  ))
);

export default MoveInAppWarning;
